import { getTokenFromStorage } from "./authentication";
import { store } from "../store/store";
const currentEnv = process.env.REACT_APP_ENV;

// set header
export function header() {
  return {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'x-api-version': '5.6',
  };
}

// set header with token
export function authHeader(token?: string) {
  let authToken = getTokenFromStorage();
  return {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'x-api-version': '5.6',
    'Authorization': 'Bearer ' + authToken,
  };
}

// set header for get engima file upload url
export function enigmaHeader(){
  let authToken = getTokenFromStorage();
  return {
    'Accept-Encoding': 'gzip, deflate, br',
    'Accept': '*/*',
    'Connection' : 'keep-alive',
    'Authorization': 'Bearer ' + authToken,
  };
}

// set header for ranger - reedem pass
export function reedemHeader(){
  let rangerToken = localStorage.getItem("RangerToken") != null ?JSON.parse(localStorage.getItem("RangerToken") || "") : null;
  return {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'x-api-version': '5.6',
    'Authorization': 'Bearer ' + rangerToken,
  };
}

export function reportHeader(){
  let isProdEnv;
  if (currentEnv === "prod" || currentEnv === "Beta") {
    isProdEnv = true;
  }
  else {
    isProdEnv = false;
  }
  return {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'x-api-version': '5.6',
    //'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMDUxNSIsInVzZXJuYW1lIjoidnN1dGhhckB5b2RlbHBhc3MuY29tIiwicm9sZSI6IllvZGVsQWRtaW4iLCJuYmYiOjE3NDU4MjAzNjEsImV4cCI6MTc3NzM1NjM1NiwiaWF0IjoxNzQ1ODIwMzYxfQ.fZVxtjzusLGFsjeoDACZUTT8x-OErajor-3qKVeaCa0', //dev
    'Authorization': isProdEnv ? 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMDU5MyIsInVzZXJuYW1lIjoidnN1dGhhckB5b2RlbHBhc3MuY29tIiwicm9sZSI6IllvZGVsQWRtaW4iLCJuYmYiOjE3NDY0MjE0NzEsImV4cCI6MTc3Nzk1NzQ2OCwiaWF0IjoxNzQ2NDIxNDcxfQ.j3uqEk4KzCZjD01ZblcQvmiCBjyRlkPO0zOQykidnZU' : //prod
      'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMDUxNSIsInVzZXJuYW1lIjoidnN1dGhhckB5b2RlbHBhc3MuY29tIiwicm9sZSI6IllvZGVsQWRtaW4iLCJuYmYiOjE3NDU4MjAzNjEsImV4cCI6MTc3NzM1NjM1NiwiaWF0IjoxNzQ1ODIwMzYxfQ.fZVxtjzusLGFsjeoDACZUTT8x-OErajor-3qKVeaCa0', //dev
  };
}

export function captchaAuthHeader(){
  let authToken = getTokenFromStorage();
  let token = store.getState().global.reCaptchaToken;
  return {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'x-api-version': '5.5',
    'CaptchaToken' : token,
    'Authorization': 'Bearer ' + authToken,
  };
}